<template>
    <div class="single-view">
        <transition name="fade" mode="out-in">
            <section class="section view-single">
                <div class="container">
                    <div class="columns">
                        <div class="column view-single__header-start">
                            <a class="button-more button-more--back" :href="$router.resolve({ name: 'home'}).href" @click.prevent="$router.push('/')">{{ $t("back") }}</a>
                            <h1 class="title">{{ post.title }}</h1><br />
                            <download-file
                                class="download-file"
                                v-if="post.show"
                                :file-id="post.download ? post.download : post.file_id"
                                :file="post.file"
                                :post-lang="post.lang"
                            >
                                <a
                                    class="button"
                                    href="#"
                                    @click.prevent="$ga.event('files', 'download', post.file)"
                                >{{ $t("download-pdf") }}</a>
                            </download-file>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <hr />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="content" v-if="post.content" v-html="post.content"></div>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <flexible-content
            :data="block"
        >
        </flexible-content>
    </div>
</template>

<script>
import axios from 'axios'
import FlexibleContent from '@/components/FlexibleContent.vue'
import DownloadFile from '@/components/DownloadFile.vue'
export default {
    components: {
        'flexible-content': FlexibleContent,
        'download-file': DownloadFile
    },
    computed: {
        block() {
            let blockId = this.$store.getters.getOption('single_footer_block_' + this.$i18n.locale)
            return this.$store.getters.getBlock(blockId)
        },
        post() {
            return this.$store.getters.getPost(this.$route.params.id)
        },
        postsPage() {
            return this.$store.getters.getOptionsPostsPage
        },
        seoTitle() {
            // get slug of post
            let slug = this.post.slug;
            // get seo title
            let postSeoTitle = this.$store.getters.getPostSeoTitle(slug)
            // if its empty then
            return (postSeoTitle == '' || postSeoTitle === undefined || postSeoTitle === null) ? this.$store.getters.getPostTitle(slug) : postSeoTitle
        }
    },
    metaInfo() {
        return {
            title: this.seoTitle
        }
    }
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.view-single
    background-color: $white
    &__header-start
        display: flex
        align-items: center
        position: relative
        +mobile
            display: block
        .button-more
            position: absolute
            left: 0.75rem
            top: 0.75rem
            +mobile
                position: static
                width: 100%
                margin-bottom: 20px
        .download-file
            position: absolute
            left: 0.75rem
            bottom: 0.75rem
            +mobile
                position: static
    &__city
        cursor: pointer
        .content
            background-image: url('../../public/img/card-header.png')
            background-size: cover
            text-align: center
            line-height: 1.3
            p
                color: $white
                font-size: $size-3
                padding: 10% 5%
                span
                    font-size: $size-6
.title
    margin-top: 80px
/deep/ .content
    p
        padding: 0 50px
/deep/ .content blockquote
    background-color: $pink
    border-left: 0
    margin-top: 50px
    p
        color: #FFF
        padding: 0 10px
    strong
        color: #FFF
</style>
